import { render, staticRenderFns } from "./ContractTemplatesList.vue?vue&type=template&id=73971695&scoped=true&"
import script from "./ContractTemplatesList.vue?vue&type=script&lang=js&"
export * from "./ContractTemplatesList.vue?vue&type=script&lang=js&"
import style0 from "./ContractTemplatesList.vue?vue&type=style&index=0&id=73971695&lang=scss&scoped=true&"
import style1 from "./ContractTemplatesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73971695",
  null
  
)

export default component.exports